import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authSlice from "../features/auth/authSlice";
import apiKeySlice from "../features/apiKey/apiKeySlice";
import domainSlice from "../features/domains/domainSlice";
import roleSlice from "../features/roles/roleSlice";
import discoverySlice from '../features/discovery/discoverySlice';
import passwordSlice from "../features/password/passwordSlice";
import planUsageSlice from "../features/planUsage/planUsageSlice";
import planUpgradeSlice from "../features/planUpgrade/planUpgradeSlice";
import billingInformationsSlice from "../features/billingInformations/billingInformationsSlice";
import invoiceSlice from "../features/invoices/invoiceSlice";
import paymentMethodSlice from "../features/paymentMethod/paymentMethodSlice";
import profileInformationsSlice from "../features/profileInformations/profileInformationsSlice";
import usageSlice from "../features/usage/usageSlice";
import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit';
import transferSlice from "../features/transfers/transferSlice";
import apiReferenceSlice from "../features/apiReference/apiReferenceSlice";

const combinedReducer = combineReducers({
    auth: authSlice,
    apiKey: apiKeySlice,
    domain: domainSlice,
    role: roleSlice,
    discovery: discoverySlice,
    password: passwordSlice,
    planUsage: planUsageSlice,
    planUpgrade: planUpgradeSlice,
    billingInformations: billingInformationsSlice,
    invoice: invoiceSlice,
    paymentMethod: paymentMethodSlice,
    profileInformations: profileInformationsSlice,
    usage: usageSlice,
    transfer: transferSlice,
    apiReference: apiReferenceSlice,
});

const rootReducer = (state: any, action: any) => {

    // Clear all data in redux store to initial on logout && login.
    if (action.type === 'auth/logout/fulfilled') {
        state = undefined;
    }

    return combinedReducer(state, action);
};

export const rtkQueryErrorLogger: Middleware =
    (api: MiddlewareAPI) => (next) => (action) => {
        if (isRejectedWithValue(action)) {
        }
        return next(action)
    }

export const store = configureStore({
    reducer: rootReducer,
    middleware: middlewares => middlewares().concat(rtkQueryErrorLogger),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
